(() => {
  'use strict';

  const mobile = window.matchMedia('(max-width: 749px)');
  const gallerySelector = "main[data-template^='product'] media-gallery";
  const videoSlideSelector = 'slideshow-slide.product-media-container--video, slideshow-slide.product-media-container--external_video';

  function getMainSlides(gallery) {
    const slideshow = gallery.slideshow;
    if (slideshow?.slides?.length) return Array.from(slideshow.slides);

    const component = gallery.querySelector('slideshow-component');
    return component ? Array.from(component.querySelectorAll('slideshow-slide.product-media-container')) : [];
  }

  function getReferenceRatio(slides) {
    const reference = slides.find((slide) => slide.classList.contains('product-media-container--image')) || slides[0];
    if (!reference) return '1';

    const inlineRatio = reference.style.getPropertyValue('--media-preview-ratio').trim();
    const computedRatio = getComputedStyle(reference).getPropertyValue('--media-preview-ratio').trim();
    return inlineRatio || computedRatio || '1';
  }

  function prepareGallery(gallery) {
    const slides = getMainSlides(gallery);
    if (!slides.some((slide) => slide.matches(videoSlideSelector))) return;

    gallery.dataset.aryMobileVideoReady = 'true';
    gallery.style.setProperty('--ary-mobile-gallery-ratio', getReferenceRatio(slides));
  }

  function prepareAll(root = document) {
    root.querySelectorAll?.(gallerySelector).forEach(prepareGallery);
  }

  async function openVideoInDialog(event, button) {
    if (!mobile.matches || button.closest('zoom-dialog')) return;

    const slide = button.closest(videoSlideSelector);
    const gallery = button.closest('media-gallery');
    if (!slide || !gallery) return;

    const zoomDialog = gallery.querySelector('zoom-dialog');
    if (!zoomDialog || typeof zoomDialog.open !== 'function') return;

    const slides = getMainSlides(gallery);
    const index = slides.indexOf(slide);
    if (index < 0) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    await Promise.resolve(zoomDialog.open(index, event));

    requestAnimationFrame(() => {
      const modalItems = zoomDialog.refs?.media?.length
        ? Array.from(zoomDialog.refs.media)
        : Array.from(zoomDialog.querySelectorAll('.dialog-zoomed-gallery > .product-media-container'));
      const deferredMedia = modalItems[index]?.querySelector('deferred-media');
      if (!deferredMedia) return;

      if (deferredMedia.hasAttribute('data-media-loaded')) {
        deferredMedia.playMedia?.();
      } else {
        deferredMedia.showDeferredMedia?.();
      }
    });
  }

  document.addEventListener(
    'click',
    (event) => {
      if (!(event.target instanceof Element)) return;

      const button = event.target.closest('.deferred-media__poster-button');
      if (!(button instanceof HTMLButtonElement)) return;
      if (!button.closest(videoSlideSelector)) return;

      openVideoInDialog(event, button);
    },
    true
  );

  prepareAll();

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (!(node instanceof Element)) continue;
        if (node.matches?.(gallerySelector)) prepareGallery(node);
        prepareAll(node);
      }
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
